import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "wbg",
  style: {
    "height": "calc(100vh - 100px)"
  }
};
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_EmdEnumValueListView = _resolveComponent("EmdEnumValueListView");
  const _component_SiteNavListView = _resolveComponent("SiteNavListView");
  const _component_SiteKeywordsListView = _resolveComponent("SiteKeywordsListView");
  const _component_SiteFooterView = _resolveComponent("SiteFooterView");
  const _component_SiteFriendLinkView = _resolveComponent("SiteFriendLinkView");
  const _component_SitePageView = _resolveComponent("SitePageView");
  const _component_BannerConfigView = _resolveComponent("BannerConfigView");
  const _component_SitePageStatisticView = _resolveComponent("SitePageStatisticView");
  const _component_SchoolListView = _resolveComponent("SchoolListView");
  const _component_HotSearchView = _resolveComponent("HotSearchView");
  const _component_SiteCountdownArticleView = _resolveComponent("SiteCountdownArticleView");
  const _component_FriendNoticeView = _resolveComponent("FriendNoticeView");
  const _component_RegionView = _resolveComponent("RegionView");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createBlock(_component_el_row, {
    class: "PcSiteViewContainer wd100"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3,
      class: "wbg pd12 box colFlex brd6 ft14"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.navs, (nv, nvi) => {
        return _openBlock(), _createElementBlock("div", {
          key: `nav_${nvi}`,
          onClick: $event => $data.curNav = nvi,
          class: _normalizeClass(`nav ${$data.curNav == nvi ? 'activeNav' : ''} mb12 pd6 box brd6 ptr`)
        }, [_createElementVNode("span", null, _toDisplayString(nv), 1)], 10, _hoisted_1);
      }), 128))]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21,
      class: "colFlex box",
      style: {
        "padding-left": "12px"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [$data.curNav == 0 ? (_openBlock(), _createBlock(_component_EmdEnumValueListView, {
        key: 0,
        type: "PC_SITE",
        "init-query": {
          sort: true,
          type: 'PC_SITE',
          sort: true,
          extra: true,
          labelSlot: true
        },
        "add-btn": "添加站点",
        title: "站点管理",
        sort: ""
      }, {
        label: _withCtx(data => [_createElementVNode("span", {
          style: {
            "color": "#009FFF"
          },
          onClick: $event => $options.configSite(data.data),
          class: "ptr"
        }, _toDisplayString(data.data.label), 9, _hoisted_3)]),
        extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
        _: 1
      })) : _createCommentVNode("", true), $data.curNav == 1 ? (_openBlock(), _createBlock(_component_SiteNavListView, {
        key: 1
      })) : _createCommentVNode("", true), $data.curNav == 2 ? (_openBlock(), _createBlock(_component_SiteKeywordsListView, {
        key: 2
      })) : _createCommentVNode("", true), $data.curNav == 3 ? (_openBlock(), _createBlock(_component_SiteFooterView, {
        key: 3
      })) : _createCommentVNode("", true), $data.curNav == 4 ? (_openBlock(), _createBlock(_component_SiteFriendLinkView, {
        key: 4
      })) : _createCommentVNode("", true), $data.curNav == 5 ? (_openBlock(), _createBlock(_component_SitePageView, {
        key: 5
      })) : _createCommentVNode("", true), $data.curNav == 6 ? (_openBlock(), _createBlock(_component_BannerConfigView, {
        key: 6
      })) : _createCommentVNode("", true), $data.curNav == 7 ? (_openBlock(), _createBlock(_component_SitePageStatisticView, {
        key: 7
      })) : _createCommentVNode("", true), $data.curNav == 8 ? (_openBlock(), _createBlock(_component_SitePageView, {
        key: 8,
        deleted: ""
      })) : _createCommentVNode("", true), $data.curNav == 9 ? (_openBlock(), _createBlock(_component_SchoolListView, {
        key: 9
      })) : _createCommentVNode("", true), $data.curNav == 10 ? (_openBlock(), _createBlock(_component_HotSearchView, {
        key: 10
      })) : _createCommentVNode("", true), $data.curNav == 11 ? (_openBlock(), _createBlock(_component_SiteCountdownArticleView, {
        key: 11
      })) : _createCommentVNode("", true), $data.curNav == 12 ? (_openBlock(), _createBlock(_component_FriendNoticeView, {
        key: 12
      })) : _createCommentVNode("", true), $data.curNav == 13 ? (_openBlock(), _createBlock(_component_RegionView, {
        key: 13
      })) : _createCommentVNode("", true)])]),
      _: 1
    })]),
    _: 1
  });
}